import { render, staticRenderFns } from "./RmaCaseDetails.vue?vue&type=template&id=ce5381e2&scoped=true&"
import script from "./RmaCaseDetails.vue?vue&type=script&lang=js&"
export * from "./RmaCaseDetails.vue?vue&type=script&lang=js&"
import style0 from "./RmaCaseDetails.vue?vue&type=style&index=0&id=ce5381e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce5381e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VIcon,VSelect,VTab,VTabItem,VTabs,VTabsItems})
